const map = {
  '#CC9B6D': {
    pri: '#CC9B6D',
    checked: '#EFAE7E',
    infobox: '#FFF4E2'
  },
  '#778566': {
    pri: '#778566',
    checked: '#a7bf88',
    infobox: '#f0f8f5'
  },
  '#334257': {
    pri: '#334257',
    checked: '#517FA4',
    infobox: '#E9F5FC'
  },
  '#476072': {
    pri: '#476072',
    checked: '#517fa4',
    infobox: '#e9f5fc'
  },
  '#548CA8': {
    pri: '#548CA8',
    checked: '#DD9898',
    infobox: '#F2FBFF'
  },
  '#944747': {
    pri: '#944747',
    checked: '#F1856E',
    infobox: '#FFEDE9'
  },
  '#BD4B4B': {
    pri: '#BD4B4B',
    checked: '#F1856E',
    infobox: '#FFEDE9'
  },
  '#706863': {
    pri: '#706863',
    checked: '#CCA16E',
    infobox: '#F6F6F6'
  },
  '#49676E': {
    pri: '#49676E',
    checked: '#6EABA0',
    infobox: '#F2FFFD'
  },
  '#68A89C': {
    pri: '#68A89C',
    checked: '#75A9B9',
    infobox: '#EBF4F3'
  },
  '#AB7F56': {
    pri: '#AB7F56',
    checked: '#E9AE67',
    infobox: '#FFFAE7'
  }
}
export const cmap = () => {
  return map
}
export const colorMap = (theme) => {
  return map[theme]
}
export const colorKey = () => {
  return Object.keys(map)
}
export const emoji = () => {
  return [
    '😃', '😄', '😅', '😆', '😊', '😎', '😇', '😈', '😏', '🤣', '🤩', '🤪', '🥳', '😁', '😀', '😂', '🤠', '🤡', '🤑', '🤓', '🤖',
    '😗', '😚', '😘', '😙',
    '😉', '🤗', '😍', '🥰', '🤤', '😋', '😛', '😜', '😝',
    '😶', '🙃', '😐', '😑', '🤔', '🤨', '🧐',
    '🤭', '🤫', '😯', '🤐', '😌', '😖', '😕', '😳', '😔', '🤥', '🥴',
    '😮', '😲', '🤯',
    '😩', '😫', '🥱', '😪', '😴', '😵',
    '😦', '😞', '😥', '😟',
    '😢', '😭',
    '🤢', '🤮', '😷', '🤒', '🤕', '🥵', '🥶',
    '🥺', '😬', '😓', '😰', '😨', '😱',
    '😒', '😠', '😡', '😤', '😣', '😧', '🤬',
    '😸', '😹', '😺', '😻', '😼', '😽', '😾', '😿', '🙀',
    '👍', '👎', '🖒', '🖓', '👌', '🖏', '✌', '🖔', '👋', '🤝', '👏', '🤘', '🤟', '🤙', '🤏', '🙌', '🙏', '🖖', '🤞', '✋', '🤚', '🖐', '🖑', '🤲', '👐', '👊', '🤛', '🤜', '🖕', '☜', '☞', '☝', '☟', '🖗', '👈', '👉', '👆', '👇', '🖘', '🖙', '🖞', '🖟', '☚', '☛', '🖜', '🖝', '🖢', '🖣', '🖚', '🖛', '🖠', '🖡',
    '🐭', '🐹', '🐰', '🐶', '🐺', '🦊', '🐯', '🦁', '🦒', '🦓', '🐴', '🐮', '🐷', '🐽', '🐻', '🐼', '🐸', '🐲', '🦄', '🐵', '🙈', '🙉', '🙊', '🐱', '🐾', '😸', '😹', '😺', '😼', '😻', '😽', '😾', '😿', '🙀',
    '🐅', '🐆', '🐘', '🦏', '🦛', '🐃', '🐂', '🐄', '🐒', '🦍', '🦧', '🦥', '🦘', '🐨', '🦌', '🐐', '🐏', '🐑', '🐎', '🦙', '🐪', '🐫', '🐗', '🐖', '🐉', '🦖', '🦕', '🐈', '🐕', '🐩', '🐇', '🐿', '🦨', '🦝', '🦡', '🦔', '🦦', '🐀', '🐁', '🦇', '🐍', '👣',
    '🐋', '🐳', '🐬', '🦈', '🐟', '🐠', '🐡', '🐙', '🦑', '🦐', '🦀', '🐚', '🐌', '🦞', '🦪', '🐢', '🦎', '🐊', '🏇', '🎠', '♘', '♞',
    '🐀', '🐃', '🐅', '🐇', '🐉', '🐍', '🐎', '🐐', '🐒', '🐓', '🐕', '🐖',
    '🐦', '🦅', '🦉', '🦜', '🕊', '🦩', '🐧', '🦚', '🦃', '🦢', '🦆', '🐓', '🐔', '🐣', '🐤', '🐥',
    '🤦', '🤷', '🙅', '🙆', '🙋', '🙌', '🙍', '🙎', '🙇', '🙏',
    '👯', '💃', '🕺', '🤳', '💇', '💈', '💆', '🧖', '🧘', '🧍', '🧎', '👰', '🤰', '🤱',
    '🔴', '🔵', '🟠', '🟡', '🟢', '🟣', '🟤', '🞄', '●', '⚫', '⬤', '⚬', '○', '⚪', '◯', '◌', '❍', '🔾', '🔿', '🞅', '🞆', '🞇', '🞈', '🞉', '🞊', '🞋', '◴', '◵', '◶', '◷', '◔', '◕', '◖', '◗', '⯊', '⯋', '◐', '◑', '◓', '◒', '◘', '◙', '◚', '◛', '◍', '⚆', '⚇', '⚈', '⚉', '◜', '◝', '◞', '◟', '◠', '◡', '🟥', '🟦', '🟧', '🟨', '🟩', '🟪', '🟫', '⯀', '■', '⬛', '◼', '◾', '🞍', '▪', '🞌', '□', '⬜', '◻', '◽', '▫', '🞎', '🞏', '🞐', '🞑', '🞒', '🞓', '🞔', '🞕', '🞖', '▢', '⧆', '⧇', '❏', '❐', '❑', '❒', '⧈', '▣', '▤', '▥', '▦', '▧', '▨', '▩', '◰',
    '◲', '◳', '◧', '◨', '◩', '◪', '⧉', '⧠', '◫', '⧄', '⧅', '▬', '▮', '▭', '▯', '🔺', '🔻', '🔼', '🔽', '▲', '▼', '◀', '▶', '△', '▽', '◁', '▷', '▴', '▾', '◂', '▸', '▵', '▿', '◃', '▹', '⛛', '◄', '►', '◅', '▻', '🞀', '🞂', '🞁', '🞃', '◸', '◹', '◺', '◿', '◤', '◥', '◣', '◢', '◬', '⟁', '◭', '◮', '⧨', '⧩', '💠', '🔶', '🔷', '🔸', '🔹', '⯁', '◆', '⬥', '🞙', '⬩', '🞘', '🞗', '❖', '♦', '◇', '⬦', '♢', '⛋', '◈', '🞛', '◈', '🞚', '🞜', '⟐', '⬖', '⬗', '⬘', '⬙', '⯌', '⯎', '⟡', '⟢', '⟣', '⯍', '⯏', '⌑', '⌺', '⍚', '⋄', '⧫', '◊',
    '🞞', '🞟', '🞠', '▰', '▱', '⬟', '⯂', '⬢', '⬣', '⯃', '⯄', '⛞', '⛶', '⛣', '⋈', '⧑', '⧒', '⧓', '⧔', '⧕', '⧖', '⧗', '⧪', '⧬', '⧭', '⧮', '⧯', '⧰', '⧱', '⧲', '⧳', '🟕', '🟖', '🟗',
    '🛑', '⛔', '🚫', '⚠', '☡', '⛒', '⛌', '⛐', '⛍', '⛛', '🚶', '🚷', '🚸', '⛖', '⛗', '⛘', '⛙', '⛜', '⛠', '⛡', '⛕', '⛚', '♿', '✈', '✆', '☎', '☏', '⛽', '⛾', '🚥', '🚦', '🚧', '🚨', '🚬', '🚭', '🚮', '🚯', '🚰', '🚱', '🚲', '🚳', '🚴', '🚵', '⚛', '☠', '☢', '☣', '⚡', '♻', '♼', '♽', '♲', '♾', '♺', '♳', '♴', '♵', '♶', '♷', '♸', '♹', '🚹', '🚺', '🚻', '🚼', '🚽', '🚾', '🛂', '🛃', '🛄', '🛅', '♨', '⛫', '⛬', '⛼', '⛻', '⛯',
    '🚲', '🛴', '🛵', '🛺', '🏍', '🚕', '🚖', '🚗', '🚘', '🚔', '🚓', '🚙', '🚜', '🚑', '🚒', '🏎', '⛟', '🚚', '🚛', '🚏', '🚌', '🚍', '🚎', '🚐', '🚉', '🚂', '🚆', '🚄', '🚅', '🚝', '🚃', '🚇', '🚈', '🚊', '🚋', '🚞', '🛤', '🚟', '🚠', '🚡', '⛴', '🚢', '⛵', '🚣', '🚤', '🛥', '🛫', '🛬', '🛩', '✈', '🛧', '🛪', '🛨', '🛦', '🚁', '🚀', '🛸', '🙬', '🙭', '🙮', '🙯',
    '💰', '💱', '💲', '💳', '💴', '💵', '💶', '💷', '💸', '🧾', '💅', '🛒', '🔮', '💎', '💍', '🎀', '🕯', '🔦', '🔔', '🕭', '⌚', '⌛', '⏳', '⚿', '🗝', '🔑', '🔏', '🔐', '🔒', '🔓', '🎨', '🎖', '🎗', '🔪', '🗡', '⚔', '🔫', '🥆', '💣', '🧨', '🎃', '🎁', '🎂', '🎈', '🎉', '🎊', '🎬', '🎭', '🎫', '🎞',
    '🚪', '🚿', '🛀', '🛁', '🚽', '🧻', '🧼', '🧽', '🧴', '🪒', '🧹', '🧺', '💺', '🧳', '🗺', '💊', '🩸', '💉', '🩹', '🩺', '🧮', '🔬', '🔭', '🧪', '🧫', '⚖', '⚗', '🧬', '🧰', '🧲', '🔩', '🔧', '🔨', '⛏', '🪓', '⛓', '⚙', '⛭', '⛮', '🗜', '🧱', '🧸', '🎎', '🕳', '🎍', '🏮', '🎏', '🎐', '🪁', '⚰', '⚱', '🏺', '⚓', '🕎', '📿', '🧿', '🧧', '🧩', '🧯', '🧵', '🧶', '🧷', '🪑', '🪔', '🪕', '🪀',
    '📧', '✉', '🖂', '🖃', '🖄', '🖅', '🖆', '📨', '📤', '📥', '📩', '📪', '📫', '📬', '📭', '📮', '📦', '📯', '📜', '📃', '📄', '🗎', '🗏', '🗐', '🗅', '🗆', '🗇', '🗈', '🗉', '🗊', '🗋', '🗌', '🗍', '🗒', '📓', '📔', '📝', '📒', '📋', '🕮', '📖', '📕', '📗', '📘', '📙', '📚', '📰', '🗞', '🗟', '📁', '📂', '🖿', '🗀', '🗁', '🗂', '🗃', '🗄', '📑', '🔖', '🔗', '🗓', '📅', '📆', '📇', '✍', '🖎', '🖊', '🖋', '🖌', '🖍', '🖉', '✏', '✐', '✎', '✑', '✒', '📌', '🖈', '📍', '📎', '🖇', '📏', '📐', '✂', '✄', '✁', '✃', '💼', '📛', '💹', '📈', '📉', '📊', '🗠',
    '⌖', '⯐', '▮', '▯', '❘', '❙', '❚', '⌶', '⌚', '⌛', '⏳', '⧗', '⧖', '🖎', '✍', '✎', '✏', '✐', '🔲', '🔳', '🔘', '🔀', '🔁', '🔂', '🔃', '🔄', '🗘', '🔔', '🕭', '🔕', '⚿', '🗝', '🔑', '🔏', '🔐', '🔒', '🔓', '📶', '🖼', '🖽', '🖾', '🗔', '🗕', '🗖', '🗗', '⎚', '🗙', '⌧', '🏷', '👁', '🖵', '🖶', '🖷', '🖹', '🖺', '🖻', '🗑', '🗜', '🗚', '🗛', '🔗', '⚓', '⎓', '⏚', '⏛', '⏦', '⏧', '⎏', '⎐', '🗺', '🌍', '🌎', '🌏', '🌐',
    '🏁', '⚐', '⚑', '🏳', '🏴', '🚩', '🎌', '⛳', '⛿',
    '👙', '🩱', '👗', '👚', '🎀', '🩰', '👘', '🥻', '👠', '👡', '👢', '🥿', '👛', '👜', '🛍', '👝', '💅', '💎', '💍', '👔', '👕', '🎽', '👖', '🩲', '🩳', '👞', '👟', '🥾', '🧣', '🧤', '🧥', '🧦', '👒', '🧢', '👑', '🎩', '🎓', '⛑', '🥼', '🎒', '👓', '🕶', '🥽', '🤿',
    '•', '◦', '‣', '⦿', '⦾', '⁃', '◘', '❥', '⁌', '⁍', '☙', '❧', '◉', '◎', '⮾', '⮿', '✓', '✔', '⍻', '🗸', '𐄂', '❌', '❎', '✗', '✘', '☐', '☑', '🗹', '⮽', '🗳', '☒', '🗴', '🗵', '🗶', '🗷', '❓', '❔', '?',
    '👶', '🧒', '👦', '👧', '👩', '👨', '🧑', '🧔', '🧓', '👴', '👵', '👤', '👥', '👪', '👫', '👬', '👭', '👱', '👳', '👲', '🧕', '👸', '🤴', '🎅', '🤶',
    '🧏', '🦻', '🦮', '🦯', '🦺', '🦼', '🦽', '🦾', '🦿', '🤵', '👮', '👷', '💁', '💂', '🕴', '🕵', '🦸', '🦹', '🧙', '🧚', '🧜', '🧝', '🧞', '🧛', '🧟',
    '👼', '👿', '👻', '👹', '👺', '👽', '👾', '🛸', '💀', '☠', '🕱', '🧠', '🦴', '👁', '👀', '👂', '👃', '👄', '🗢', '👅', '🦷', '🦵', '🦶',
    '💭', '🗬', '🗭', '💬', '🗨', '🗩', '🗪', '🗫', '🗰', '🗱', '🗮', '🗯', '🗣', '🗤', '🗥', '🗦', '🗧',
    '💦', '💧', '💢', '💫', '💤', '💨', '💥', '💪', '🗲', '🔥', '💡', '💩', '💯', '🔟', '🔰',
    '🎔', '💕', '💓', '💖', '💗', '💘', '💝', '💞', '💟', '🧡', '💛', '💚', '💙', '💜', '🖤', '❤', '🤍', '🤎', '♡', '♥', '💔',
    '🥀', '👙', '👠', '👡', '💄', '💅', '🔮', '🎕', '💐', '🌹', '🍫', '🍭', '💎', '💍', '💒', '👰', '🤳', '💋', '💌',
    '💏', '💑', '👯', '💃', '🤰', '🔥', '🔞', '🏩', '💦', '💧', '🍎', '🍑', '🍒', '🍌', '🥒', '🍆', '🤙', '🖕', '👉',
    '💮', '🌸', '🌷', '🌹', '🌺', '🌻', '🌼', '🥀', '🎕', '⚘', '🏵', '🏶', '🌱', '🌽', '🌾', '⸙',
    '🌰', '🌿', '🍀', '🍁', '🍂', '🍃', '🌵', '🌴', '🎋', '🎄', '🌲', '🌳',
    '🌣', '🌞', '⛅', '🌤', '🌥', '⛱', '🌦', '🌧', '☔', '☂', '🌂', '⛆', '🌢', '🌨', '☃', '⛄', '⛇', '❄', '❅', '❆', '🌬', '🎏', '🎐', '☁', '🌫', '🌁', '🌩', '⛈', '☇', '☈', '🌪', '🌀', '🌈'
  ]
}
